import styled from 'styled-components';
import { _gridInput } from 'theme/_mixins/inputs';

import Button from 'components/Buttons/Button';
import CheckboxComponent from 'components/Checkbox';

interface FieldProps {
  columns?: number;
}

export const TravelKindRowContainer: any = styled.section`
  display: flex;
  justify-content: space-around;
  margin-bottom: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    width: 50%;
  }
`;

TravelKindRowContainer.CheckboxContainer = styled.div`
  display: flex;

  & > span {
    margin-left: 8px;
    color: ${({ theme }) => theme.flightSearch.kindLabel};
  }
`;

TravelKindRowContainer.label = styled.span`
  font-size: 12px;
`;

export const Container = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Sector = styled.span`
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
  margin-top: 10px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

export const AddAndRemoveSectorContainer = styled.div`
  text-align: right;
  margin-bottom: 20px;
  margin-top: 20px;
`;
export const AddAndRemoveSector = styled.a`
  text-align: right;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 15px;
  color: #706967;
  cursor: pointer;
`;

export const AirplaneIcon = styled.img`
  height: 15px;
  width: 15px;
  padding-top: 3px;
`;

export const Fields = styled.ol`
  margin-top: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 80px;
  }
`;

export const Field = styled.li<FieldProps>`
  ${({ columns }) => _gridInput({ gap: 8, columns, margin: { top: 8, bottom: 8 } })};
`;

export const RoundTripIcon = styled.span`
  font-size: 25px;

  & > svg {
    display: block;

    &:last-child {
      margin-top: -15px;
    }
  }
`;

export const SearchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    margin-bottom: 32px;
  }
`;

export const SearchButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;
  width: 50%;
  margin-top: 16px;
  margin-left: auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 28px 16px 0px;
    width: 100%;
  }
`;

export const Checkbox = styled(CheckboxComponent)`
  margin-top: 24px;
  cursor: pointer;
  & > span {
    border-radius: 4px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-left: auto;
  }
`;

export const BaggageIncluded = styled.h5`
  padding-left: 15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.flightSearch.baggage};
`;
